import React from 'react';
import ball from '../Assets/Ellipse 23.png'
import halfball from '../Assets/Group 100.png'

export default function Mission() {
    return (
        <div className="outermission">
            <img id="outerMissionimg" src={halfball} alt="" />

            <div className="Mission">
                <div className="Missionleft">
                    <div className="Missionleftimg">
                        <img src={ball} alt="" />
                    </div>
                    <center>
                        <h1><span>Dedicated</span> <br />to our mission we are </h1>
                    </center>
                </div>

                <div className="Missionright">
                    <center>
                        <p>Our services include Company Formation & Renewals, <br />
                            Trust & Friduciary, Tax Residency Setup With Family, Bank <br />
                            Accounts, Remote Management, Stock Trading <br />
                            Platforms, Ownership Solutions</p>
                    </center>
                </div>
            </div>
        </div>
    );
}
